import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Benefits from '../components/Benefits';
import About from '../components/About';
import Clients from '../components/Clients';
import Certifications from '../components/Certifications';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import {
  organization,
  website,
  localBusiness,
  breadcrumb,
  wrap,
  SITE_URL,
} from '../components/seo/schemas';
import { Toaster } from '../components/ui/toaster';

const structuredData = wrap([
  organization,
  website,
  localBusiness,
  breadcrumb([{ name: 'Home', url: SITE_URL }]),
  {
    '@type': 'WebPage',
    '@id': `${SITE_URL}/#webpage`,
    url: SITE_URL,
    name: 'Upscale — Growth Marketing Agency in Oslo, Norway',
    description:
      'Upscale helps startups gain early-adopter traction and sustained user growth through data-driven strategies. Google Premier Partner. HubSpot Certified. Oslo, Norway.',
    inLanguage: 'en',
    isPartOf: { '@id': `${SITE_URL}/#website` },
    about: { '@id': `${SITE_URL}/#organization` },
    primaryImageOfPage: `${SITE_URL}/og-image.png`,
  },
]);

const HomePage = () => {
  return (
    <div>
      <SEO
        title="Upscale | Growth Marketing Agency in Oslo, Norway - Scale Your Startup"
        description="Upscale is a growth and marketing agency helping startups gain early-adopter traction and sustained user growth through data-driven strategies. Based in Oslo, Norway. Google Premier Partner, HubSpot Certified."
        keywords="growth marketing, startup marketing, digital marketing Oslo, marketing agency Norway, growth hacking, early adopters, user acquisition, Google Premier Partner, HubSpot certified, performance marketing, lead generation"
        canonicalUrl={SITE_URL}
        ogTitle="Upscale — Data-driven growth marketing for startups"
        ogDescription="We help startups gain early-adopter traction and sustained user growth. Oslo-based, working globally. Google Premier Partner + HubSpot Certified."
        structuredData={structuredData}
      />
      <Navbar />
      <Hero />
      <Services />
      <Benefits />
      <About />
      <Clients />
      <Certifications />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
};

export default HomePage;
